module.exports = __webpack_public_path__ + "img/xiazai-quxiao.07d02634.png";